var map = {
	"./behind_the_dhara.gif": "./src/EGRContent/Story/BunukoChasma/images/behind_the_dhara.gif",
	"./behind_the_dhara.png": "./src/EGRContent/Story/BunukoChasma/images/behind_the_dhara.png",
	"./between_the_book.gif": "./src/EGRContent/Story/BunukoChasma/images/between_the_book.gif",
	"./between_the_book.png": "./src/EGRContent/Story/BunukoChasma/images/between_the_book.png",
	"./bg_bed.png": "./src/EGRContent/Story/BunukoChasma/images/bg_bed.png",
	"./bg_books.png": "./src/EGRContent/Story/BunukoChasma/images/bg_books.png",
	"./bg_main.png": "./src/EGRContent/Story/BunukoChasma/images/bg_main.png",
	"./bg_table.png": "./src/EGRContent/Story/BunukoChasma/images/bg_table.png",
	"./bunu01.gif": "./src/EGRContent/Story/BunukoChasma/images/bunu01.gif",
	"./bunu01.png": "./src/EGRContent/Story/BunukoChasma/images/bunu01.png",
	"./bunu02.gif": "./src/EGRContent/Story/BunukoChasma/images/bunu02.gif",
	"./bunu02.png": "./src/EGRContent/Story/BunukoChasma/images/bunu02.png",
	"./bunu_front_of_mirror.gif": "./src/EGRContent/Story/BunukoChasma/images/bunu_front_of_mirror.gif",
	"./bunu_front_of_mirror.png": "./src/EGRContent/Story/BunukoChasma/images/bunu_front_of_mirror.png",
	"./bunu_jump_run.gif": "./src/EGRContent/Story/BunukoChasma/images/bunu_jump_run.gif",
	"./bunu_jump_run.png": "./src/EGRContent/Story/BunukoChasma/images/bunu_jump_run.png",
	"./bunu_thinking.gif": "./src/EGRContent/Story/BunukoChasma/images/bunu_thinking.gif",
	"./bunu_thinking.png": "./src/EGRContent/Story/BunukoChasma/images/bunu_thinking.png",
	"./bunu_walking.gif": "./src/EGRContent/Story/BunukoChasma/images/bunu_walking.gif",
	"./bunu_walking.png": "./src/EGRContent/Story/BunukoChasma/images/bunu_walking.png",
	"./bunu_where_i_left.gif": "./src/EGRContent/Story/BunukoChasma/images/bunu_where_i_left.gif",
	"./bunu_where_i_left.png": "./src/EGRContent/Story/BunukoChasma/images/bunu_where_i_left.png",
	"./bunu_with_comp.gif": "./src/EGRContent/Story/BunukoChasma/images/bunu_with_comp.gif",
	"./bunu_with_comp.png": "./src/EGRContent/Story/BunukoChasma/images/bunu_with_comp.png",
	"./cover_banner.png": "./src/EGRContent/Story/BunukoChasma/images/cover_banner.png",
	"./cover_page.png": "./src/EGRContent/Story/BunukoChasma/images/cover_page.png",
	"./in_the_bag.gif": "./src/EGRContent/Story/BunukoChasma/images/in_the_bag.gif",
	"./in_the_bag.png": "./src/EGRContent/Story/BunukoChasma/images/in_the_bag.png",
	"./last_page.png": "./src/EGRContent/Story/BunukoChasma/images/last_page.png",
	"./on_the_table.gif": "./src/EGRContent/Story/BunukoChasma/images/on_the_table.gif",
	"./on_the_table.png": "./src/EGRContent/Story/BunukoChasma/images/on_the_table.png",
	"./story-banner.png": "./src/EGRContent/Story/BunukoChasma/images/story-banner.png",
	"./story-banner.svg": "./src/EGRContent/Story/BunukoChasma/images/story-banner.svg",
	"./thinking.png": "./src/EGRContent/Story/BunukoChasma/images/thinking.png",
	"./under_bed.gif": "./src/EGRContent/Story/BunukoChasma/images/under_bed.gif",
	"./under_bed.png": "./src/EGRContent/Story/BunukoChasma/images/under_bed.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/BunukoChasma/images sync recursive ^\\.\\/.*$";